import React from 'react';

interface IStatsBoxes {
    invoices: number;
    purchases: any;
    statements?: number;
    discrepancies?: number;
}

const StatsBoxes = ({
    invoices,
    purchases,
    statements,
    discrepancies
}: IStatsBoxes) => {
    return (
        <div className='my-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4'>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Total Invoices Processed</p>
                <p className='mt-5 font-bold text-[17px]'>{invoices || 0}</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Total Purchase Orders Analyzed</p>
                <p className='mt-5 font-bold text-[17px]'>{purchases || 0}</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Total Statements Analyzed</p>
                <p className='mt-5 font-bold text-[17px]'>{statements || 0}</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Discrepancies</p>
                <p className='mt-5 font-bold text-[17px]'>{discrepancies || 0}</p>
            </div>
        </div>
    )
}
export default StatsBoxes;